import React from 'react';
import styled from 'styled-components';
import { useServiceCatalog } from './ServiceCatalogContext';
import ProductCard from './ProductCard';

const ServicesPageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 2rem;
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 1rem;
`;

const PageIntro = styled.p`
  font-size: 1.1rem;
  text-align: center;
  color: #555;
  margin-bottom: 3rem;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
`;

const ServiceCategoryPage = ({ category, title, intro }) => {
    const { allServices } = useServiceCatalog();
    const services = allServices.filter(service => service.category === category);

    return (
        <ServicesPageContainer>
            <PageTitle>{title}</PageTitle>
            <PageIntro>{intro}</PageIntro>
            <ServicesGrid>
                {services.map(service => <ProductCard key={service.id} service={service} />)}
            </ServicesGrid>
        </ServicesPageContainer>
    );
};

export default ServiceCategoryPage;